import { entryChannels } from "@/mocks/home";

const stats = [
  { label: "当前可用线路", value: "6 / 6" },
  { label: "今日更新条数", value: "148" },
  { label: "归档合集", value: "1,240" },
];

export default function HeroSection() {
  const preview = entryChannels.slice(0, 3);

  return (
    <section id="top" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 pt-10 md:pt-16 pb-8 md:pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-7 animate-fade-up">
            <div className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-link text-xs text-primary-600"></i>
              </span>
              <span className="text-xs tracking-wide text-foreground-600">
                入口 · 网址 · 地址 · 链接 一站导航
              </span>
            </div>

            <h2 className="mt-5 font-heading text-3xl md:text-5xl font-black leading-tight tracking-tight text-foreground-950">
              黑料平台入口导航
              <span className="block mt-2 text-primary-600">
                一条链接直达最新首页
              </span>
            </h2>

            <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
              黑料平台入口直达，提供最新可用的网址、地址与链接信息。解决找不到首页、无法访问的困扰，快速进入黑料平台，浏览热门爆料与吃瓜内容。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#entries"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 dark:text-foreground-950 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                获取最新可用入口
              </a>
              <a
                href="#faq"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 whitespace-nowrap cursor-pointer"
              >
                查看访问说明
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
              {stats.map((s) => (
                <div key={s.label}>
                  <dt className="text-xs text-foreground-500">{s.label}</dt>
                  <dd className="mt-1 font-heading text-xl md:text-2xl font-bold text-foreground-950">
                    {s.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <aside className="lg:col-span-5 w-full animate-fade-up" style={{ animationDelay: "0.12s" }}>
            <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
              <div className="relative w-full h-40 md:h-48">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20warm%20textured%20composition%20with%20layered%20paper%20shapes%20in%20terracotta%20amber%20and%20soft%20cream%20tones%2C%20soft%20diffused%20studio%20lighting%2C%20matte%20grainy%20finish%2C%20clean%20minimal%20neutral%20background%2C%20editorial%20design%20aesthetic%2C%20no%20text&width=1000&height=420&seq=hl-hero-side-01&orientation=landscape&nocache=true"
                  alt="黑料平台入口实时状态示意"
                  title="黑料平台入口 - 网址地址链接"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent"></div>
                <div className="absolute left-4 bottom-4 flex items-center gap-2">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/95 px-3 py-1 text-xs font-medium text-foreground-900">
                    <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                    线路在线
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-sm font-bold text-foreground-950">
                    今日入口速览
                  </h3>
                  <span className="text-xs text-foreground-500">实时</span>
                </div>
                <ul className="mt-4 flex flex-col gap-3">
                  {preview.map((c) => (
                    <li key={c.name} className="flex items-center justify-between gap-3">
                      <div className="min-w-0">
                        <p className="text-sm font-medium text-foreground-900 truncate">
                          {c.name}
                        </p>
                        <p className="text-xs text-foreground-500 truncate">{c.address}</p>
                      </div>
                      <span className="shrink-0 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                        {c.status}
                      </span>
                    </li>
                  ))}
                </ul>
                <p className="mt-4 text-xs leading-relaxed text-foreground-500">
                  途径地址每日巡检，遇到波动会自动标记，切换备用线路即可继续浏览爆料。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}